<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M1.38,785.95l-0.01,3.98c1.09,0.12,2.16,0.45,3.22,0.97l1.3-1.95l1.45,0.97l-1.25,1.87c0.79,0.53,1.57,1.15,2.35,1.87
	l1.28-0.64l0.78,1.56l-2.31,1.15l-0.45-0.44c-1.15-1.15-2.27-2-3.38-2.61c0.31,0.6,0.5,1.27,0.5,1.99c0,2.4-1.96,4.37-4.37,4.37
	s-4.37-1.97-4.37-4.37c0-0.72,0.19-1.39,0.5-1.99c-1.1,0.6-2.23,1.46-3.38,2.61l-0.45,0.44l-2.31-1.15l0.78-1.56l1.28,0.64
	c0.77-0.72,1.56-1.34,2.35-1.87l-1.25-1.87l1.45-0.97l1.3,1.95c1.06-0.53,2.14-0.86,3.22-0.97l0.01-3.98H1.38z M-1.25,794.68
	c0,0.98,0.77,1.75,1.75,1.75s1.75-0.77,1.75-1.75c0-0.97-0.77-1.75-1.75-1.75S-1.25,793.71-1.25,794.68z"/>
</svg>

</template>